<template>
    <div class="header">
        <Sidebar class="sidebar" :class="{ 'active' : SidebarActive }" @close="toggleNav"/>
        <div @click.prevent="toggleNav()" class="menu-icon">
            <svg class="ob-icon ob-icon--hamburger " viewBox="0 0 32 32"
                 style="fill: rgb(0, 87, 184); width: 2rem; height: 2rem; font-size: 2rem;">
                <path d="M0.8,0 L31.2,0 C31.6418278,0 32,0.477562934 32,1.06666667 C32,1.6557704 31.6418278,2.13333333 31.2,2.13333333 L0.8,2.13333333 C0.3581722,2.13333333 0,1.6557704 0,1.06666667 L0.8,0 Z M0.8,29.8666667 L31.2,29.8666667 C31.6418278,29.8666667 32,30.3442296 32,30.9333333 C32,31.5224371 31.6418278,32 31.2,32 L0.8,32 C0.3581722,32 0,31.5224371 0,30.9333333 L0.8,29.8666667 Z M0.8,14.9333333 L31.2,14.9333333 C31.6418278,14.9333333 32,15.4108963 32,16 C32,16.5891037 31.6418278,17.0666667 31.2,17.0666667 L0.8,17.0666667 C0.3581722,17.0666667 0,16.5891037 0,16 L0.8,14.9333333 Z"></path>
            </svg>
        </div>

        <div class="logo">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 231.6 77.57"><defs><linearGradient id="New_Gradient_Swatch_1" y1="38.78" x2="231.6" y2="38.78" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#002d74"/><stop offset="0.22" stop-color="#002d74" stop-opacity="0.3"/><stop offset="0.44" stop-color="#002d74" stop-opacity="0"/><stop offset="0.54" stop-color="#002d74" stop-opacity="0.17"/><stop offset="0.75" stop-color="#002d74" stop-opacity="0.6"/><stop offset="0.93" stop-color="#002d74"/></linearGradient></defs><g style="isolation:isolate"><g id="Ebene_2" data-name="Ebene 2"><g id="Layer_1" data-name="Layer 1"><path d="M113.75,46.56c-2.17,9.18-10.85,9-10.85,5C102.9,48.43,108.54,48.12,113.75,46.56Zm76.91-20.07h-8.8l-1.47,6.85h9C195.1,33.34,196.18,26.49,190.66,26.49Zm-2.14,15.87H178.45L176.79,50h10.35C192.51,50,193.08,42.36,188.52,42.36Zm43.08-3.57c0,21.42-16,38.78-37.43,38.78H37.43C16,77.56,0,60.2,0,38.78S16,0,37.43,0H194.18C215.61,0,231.6,17.37,231.6,38.79ZM67,34.54c.13-11-6.72-20.15-21.5-20.19-16.85,0-27,13.08-26.95,28.37.12,10.51,6.4,20,21.5,20C60.32,62.82,66.91,45.28,67,34.54Zm58.24,27.2a6.05,6.05,0,0,1-.51-4.62l3.78-17.52c1.79-8.41-7.15-12-16.21-12-7.08,0-13.27,1.26-17.46,7.17l1.44-6.68c-7-2.1-10.45,2.09-12.09,3.85V28.57H72.8L65.67,61.75H78.83l3.11-14.44c1.42-6.8,4.87-8.11,7.55-8.11h18c.62-4.67,9.22-4.38,8.48-1.24-.59,2.53-6.81,2.37-15.89,4-1.94.35-10.31,2.2-10.35,10.66,0,10.22,13,12.94,21.25,7v2.14Zm26.21-46.08H138l-10,46.1H141.5Zm53.6,31.7c0-5.39-2.23-7.08-5-9.23,5.49-3,7.39-6.72,7.41-11.79-.07-11.65-13.46-10.65-19.3-10.65h-18.1l-3.8,17.64H155.23l-2,9h11.09l-4.18,19.4h26.6C201.89,61.76,205.05,51.35,205.07,47.36ZM44.66,26c-6.1,0-11.39,6.22-11.37,17.48,0,4.75,2.47,7.87,7.38,7.87,8.83,0,11.43-12.42,11.46-17.55C52.14,29.65,49.64,26,44.66,26Z" style="fill:#0055b8"/><g style="mix-blend-mode:multiply"><path d="M113.75,46.56c-2.17,9.18-10.85,9-10.85,5C102.9,48.43,108.54,48.12,113.75,46.56Zm76.91-20.07h-8.8l-1.47,6.85h9C195.1,33.34,196.18,26.49,190.66,26.49Zm-2.14,15.87H178.45L176.79,50h10.35C192.51,50,193.08,42.36,188.52,42.36Zm43.08-3.57c0,21.42-16,38.78-37.43,38.78H37.43C16,77.56,0,60.2,0,38.78S16,0,37.43,0H194.18C215.61,0,231.6,17.37,231.6,38.79ZM67,34.54c.13-11-6.72-20.15-21.5-20.19-16.85,0-27,13.08-26.95,28.37.12,10.51,6.4,20,21.5,20C60.32,62.82,66.91,45.28,67,34.54Zm58.24,27.2a6.05,6.05,0,0,1-.51-4.62l3.78-17.52c1.79-8.41-7.15-12-16.21-12-7.08,0-13.27,1.26-17.46,7.17l1.44-6.68c-7-2.1-10.45,2.09-12.09,3.85V28.57H72.8L65.67,61.75H78.83l3.11-14.44c1.42-6.8,4.87-8.11,7.55-8.11h18c.62-4.67,9.22-4.38,8.48-1.24-.59,2.53-6.81,2.37-15.89,4-1.94.35-10.31,2.2-10.35,10.66,0,10.22,13,12.94,21.25,7v2.14Zm26.21-46.08H138l-10,46.1H141.5Zm53.6,31.7c0-5.39-2.23-7.08-5-9.23,5.49-3,7.39-6.72,7.41-11.79-.07-11.65-13.46-10.65-19.3-10.65h-18.1l-3.8,17.64H155.23l-2,9h11.09l-4.18,19.4h26.6C201.89,61.76,205.05,51.35,205.07,47.36ZM44.66,26c-6.1,0-11.39,6.22-11.37,17.48,0,4.75,2.47,7.87,7.38,7.87,8.83,0,11.43-12.42,11.46-17.55C52.14,29.65,49.64,26,44.66,26Z" style="fill:url(#New_Gradient_Swatch_1)"/></g></g></g></g></svg>
        </div>

    </div>
</template>

<script>
    import Sidebar from "./Sidebar";

    export default {
        name: 'Header',
        components: {Sidebar},
        props: {},
        data() {
            return {
                SidebarActive: false
            }
        },
        methods: {
            toggleNav() {
                this.SidebarActive = !this.SidebarActive
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

    .header {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        background: #fff;
        z-index: 999;
        height: 7%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .sidebar {
            position: absolute;
            left: 0;
            top: 0;
            transform: translateX(-100%);
            transition: 0.5s;
            width: 60%;
            height: 100vh;
            z-index: 999;
            will-change: transform;
            //box-shadow: -5px 0px 14px 0px rgb(0 0 0 / 0.5);

            &.active {
                transform: translateX(0%);
            }
        }

        .menu-icon {
            margin-left: 1rem;
            max-width: 5%;
            display: flex;
            align-items: center;


            @media all and (min-width: 540px) {
                max-width: 4.5%;
            }

            svg {
                width: 100%;
            }
        }

        .logo {
            margin-right: 1.25rem;
            max-width: 20%;
            z-index: 999;
            display: flex;
            align-items: center;

            svg {
                width: 100%;
            }


            @media all and (min-width: 540px) {
                max-width: 12.5%;
            }
        }
    }
</style>
